var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49.6364,
    rx: 24.8182,
    fill: "#456EFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6516_10290)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.6364,
    transform: "translate(13 15)",
    fill: "#456EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3645 31.3635L28.1178 24.8181M21.884 24.8181L14.6373 31.3635M19.3282 33.5454H30.6736C32.5065 33.5454 33.423 33.5454 34.123 33.1887C34.7388 32.8749 35.2395 32.3742 35.5533 31.7584C35.91 31.0584 35.91 30.1419 35.91 28.309V21.3272C35.91 19.4943 35.91 18.5778 35.5533 17.8778C35.2395 17.262 34.7388 16.7613 34.123 16.4475C33.423 16.0908 32.5065 16.0908 30.6736 16.0908H19.3282C17.4953 16.0908 16.5788 16.0908 15.8787 16.4475C15.2629 16.7613 14.7623 17.262 14.4485 17.8778C14.0918 18.5778 14.0918 19.4943 14.0918 21.3272V28.309C14.0918 30.1419 14.0918 31.0584 14.4485 31.7584C14.7623 32.3742 15.2629 32.8749 15.8787 33.1887C16.5788 33.5454 17.4953 33.5454 19.3282 33.5454Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0028 25.5986C26.2815 26.1035 25.9209 26.3559 25.5286 26.4537C25.1821 26.5401 24.8197 26.5401 24.4732 26.4537C24.0809 26.3559 23.7203 26.1035 22.999 25.5986L14.0918 19.3635C14.0918 17.5561 15.557 16.0908 17.3645 16.0908H32.6373C34.4447 16.0908 35.91 17.5561 35.91 19.3635L27.0028 25.5986Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6516_10290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.6364,
    fill: "white",
    transform: "translate(13 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4a4ae810f562e6d9a5bb49695704e6c1.svg";
export { ForwardRef as ReactComponent };